import { useState } from 'react';

interface Props {
  packagesForm: any;
  setPackagesForm: any;
  validating: boolean;
}
function PharmaFields({ packagesForm, setPackagesForm, validating }: Props) {
  return (
    <div
      className=''
      id='pharma_fields'
    >
      <div className='row mt-4'>
        <div className='col-sm-12 col-md-4 col-lg-6'>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='checkbox'
              id='is_time_sensitive'
              checked={packagesForm?.is_time_sensitive}
              onChange={(e) => [
                setPackagesForm({
                  ...packagesForm,
                  is_time_sensitive: e.target.checked,
                }),
              ]}
            />
            <label
              className='form-check-label globalInputLabel'
              style={{ fontWeight: '300' }}
              htmlFor='is_time_sensitive'
            >
              Is this time sensitive?
            </label>
          </div>
          {packagesForm?.is_time_sensitive && (
            <div id='time_sensitive_field'>
              <label
                className='globalInputLabel pb-2'
                htmlFor='main_pharma_hours'
              >
                Hours{' '}
                <span
                  className='text-danger fw-bold'
                  style={{ marginLeft: '5px' }}
                >
                  *
                </span>
              </label>
              <input
                className={`form-control ubbe-input ${
                  packagesForm?.time_sensitive_hours ? 'highlighted-border' : ''
                }`}
                id='main_pharma_hours'
                placeholder='Ex: 72'
                autoComplete='new-password'
                value={packagesForm?.time_sensitive_hours}
                onChange={(e) => [
                  setPackagesForm({
                    ...packagesForm,
                    time_sensitive_hours: e.target.value,
                  }),
                ]}
              />
              {validating &&
                (!packagesForm?.time_sensitive_hours ||
                  packagesForm?.time_sensitive_hours === '') && (
                  <div
                    className='error_text'
                    id='main_pharma_hours_error'
                  >
                    Please provide time sensitive hours.
                  </div>
                )}
            </div>
          )}
        </div>
        <div className='col-sm-12 col-md-4 col-lg-6'>
          <div className='form-check'>
            <input
              className='form-check-input'
              type='checkbox'
              id='is_cos'
              checked={packagesForm?.is_cos}
              onChange={(e) => [
                setPackagesForm({
                  ...packagesForm,
                  is_cos: e.target.checked,
                }),
              ]}
            />
            <label
              className='form-check-label globalInputLabel'
              style={{ fontWeight: '300' }}
              htmlFor='is_cos'
            >
              Does this require Chain of Signature?
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PharmaFields;
